import { render, staticRenderFns } from "./JourneyBuilderComposerTouchpointOverview.vue?vue&type=template&id=1d1425e0&"
import script from "./JourneyBuilderComposerTouchpointOverview.vue?vue&type=script&lang=js&"
export * from "./JourneyBuilderComposerTouchpointOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d1425e0')) {
      api.createRecord('1d1425e0', component.options)
    } else {
      api.reload('1d1425e0', component.options)
    }
    module.hot.accept("./JourneyBuilderComposerTouchpointOverview.vue?vue&type=template&id=1d1425e0&", function () {
      api.rerender('1d1425e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/JourneyBuilderComposerTouchpointOverview.vue"
export default component.exports